import type { ILanguage } from '../types';

const languages: ILanguage[] = [
  { code: 'af', english_name: 'Afrikaans', native_name: 'Afrikaans' },
  { code: 'am', english_name: 'Amharic', native_name: 'አማርኛ' },
  { code: 'ar', english_name: 'Arabic', native_name: 'العربية' },
  { code: 'as', english_name: 'Assamese', native_name: 'অসমীয়া' },
  { code: 'az', english_name: 'Azerbaijani', native_name: 'azərbaycanca' },
  { code: 'be', english_name: 'Belarusian', native_name: 'беларуская' },
  { code: 'bg', english_name: 'Bulgarian', native_name: 'български' },
  { code: 'bn', english_name: 'Bangla', native_name: 'বাংলা' },
  { code: 'bs', english_name: 'Bosnian', native_name: 'bosanski' },
  { code: 'ca', english_name: 'Catalan', native_name: 'català' },
  { code: 'cs', english_name: 'Czech', native_name: 'čeština' },
  { code: 'da', english_name: 'Danish', native_name: 'dansk' },
  { code: 'de', english_name: 'German', native_name: 'Deutsch' },
  { code: 'el', english_name: 'Greek', native_name: 'Ελληνικά' },
  { code: 'en', english_name: 'English', native_name: 'English' },
  { code: 'en-AU', english_name: 'English (Australia)', native_name: 'English (Australia)' },
  { code: 'en-CA', english_name: 'English (Canada)', native_name: 'English (Canada)' },
  { code: 'en-GB', english_name: 'English (United Kingdom)', native_name: 'English (United Kingdom)' },
  { code: 'en-US', english_name: 'English (United States)', native_name: 'English (United States)' },
  { code: 'es', english_name: 'Spanish', native_name: 'español' },
  { code: 'es-ES', english_name: 'Spanish (Spain)', native_name: 'español (España)' },
  { code: 'es-MX', english_name: 'Spanish (Mexico)', native_name: 'español (México)' },
  { code: 'et', english_name: 'Estonian', native_name: 'eesti' },
  { code: 'eu', english_name: 'Basque', native_name: 'euskara' },
  { code: 'fa', english_name: 'Persian', native_name: 'فارسی' },
  { code: 'fi', english_name: 'Finnish', native_name: 'suomi' },
  { code: 'fil', english_name: 'Filipino', native_name: 'Filipino' },
  { code: 'fr', english_name: 'French', native_name: 'français' },
  { code: 'fr-CA', english_name: 'French (Canada)', native_name: 'français (Canada)' },
  { code: 'fr-FR', english_name: 'French (France)', native_name: 'français (France)' },
  { code: 'gl', english_name: 'Galician', native_name: 'galego' },
  { code: 'gu', english_name: 'Gujarati', native_name: 'ગુજરાતી' },
  { code: 'he', english_name: 'Hebrew', native_name: 'עברית' },
  { code: 'hi', english_name: 'Hindi', native_name: 'हिन्दी' },
  { code: 'hr', english_name: 'Croatian', native_name: 'hrvatski' },
  { code: 'hu', english_name: 'Hungarian', native_name: 'magyar' },
  { code: 'hy', english_name: 'Armenian', native_name: 'հայերեն' },
  { code: 'id', english_name: 'Indonesian', native_name: 'Bahasa Indonesia' },
  { code: 'is', english_name: 'Icelandic', native_name: 'íslenska' },
  { code: 'it', english_name: 'Italian', native_name: 'italiano' },
  { code: 'ja', english_name: 'Japanese', native_name: '日本語' },
  { code: 'ka', english_name: 'Georgian', native_name: 'ქართული' },
  { code: 'kk', english_name: 'Kazakh', native_name: 'қазақ тілі' },
  { code: 'km', english_name: 'Khmer', native_name: 'ខ្មែរ' },
  { code: 'kn', english_name: 'Kannada', native_name: 'ಕನ್ನಡ' },
  { code: 'ko', english_name: 'Korean', native_name: '한국어' },
  { code: 'ky', english_name: 'Kyrgyz', native_name: 'кыргызча' },
  { code: 'lo', english_name: 'Lao', native_name: 'ລາວ' },
  { code: 'lt', english_name: 'Lithuanian', native_name: 'lietuvių' },
  { code: 'lv', english_name: 'Latvian', native_name: 'latviešu' },
  { code: 'mk', english_name: 'Macedonian', native_name: 'македонски' },
  { code: 'ml', english_name: 'Malayalam', native_name: 'മലയാളം' },
  { code: 'mn', english_name: 'Mongolian', native_name: 'монгол' },
  { code: 'mr', english_name: 'Marathi', native_name: 'मराठी' },
  { code: 'ms', english_name: 'Malay', native_name: 'Bahasa Melayu' },
  { code: 'my', english_name: 'Burmese', native_name: 'မြန်မာ' },
  { code: 'nb', english_name: 'Norwegian Bokmål', native_name: 'norsk bokmål' },
  { code: 'ne', english_name: 'Nepali', native_name: 'नेपाली' },
  { code: 'nl', english_name: 'Dutch', native_name: 'Nederlands' },
  { code: 'or', english_name: 'Odia', native_name: 'ଓଡ଼ିଆ' },
  { code: 'pa', english_name: 'Punjabi', native_name: 'ਪੰਜਾਬੀ' },
  { code: 'pl', english_name: 'Polish', native_name: 'polski' },
  { code: 'pt', english_name: 'Portuguese', native_name: 'português' },
  { code: 'pt-BR', english_name: 'Portuguese (Brazil)', native_name: 'português (Brasil)' },
  { code: 'pt-PT', english_name: 'Portuguese (Portugal)', native_name: 'português (Portugal)' },
  { code: 'ro', english_name: 'Romanian', native_name: 'română' },
  { code: 'ru', english_name: 'Russian', native_name: 'русский' },
  { code: 'si', english_name: 'Sinhala', native_name: 'සිංහල' },
  { code: 'sk', english_name: 'Slovak', native_name: 'slovenčina' },
  { code: 'sl', english_name: 'Slovenian', native_name: 'slovenščina' },
  { code: 'sq', english_name: 'Albanian', native_name: 'shqip' },
  { code: 'sr', english_name: 'Serbian', native_name: 'српски' },
  { code: 'sv', english_name: 'Swedish', native_name: 'svenska' },
  { code: 'sw', english_name: 'Swahili', native_name: 'Kiswahili' },
  { code: 'ta', english_name: 'Tamil', native_name: 'தமிழ்' },
  { code: 'te', english_name: 'Telugu', native_name: 'తెలుగు' },
  { code: 'th', english_name: 'Thai', native_name: 'ไทย' },
  { code: 'tr', english_name: 'Turkish', native_name: 'Türkçe' },
  { code: 'uk', english_name: 'Ukrainian', native_name: 'українська' },
  { code: 'ur', english_name: 'Urdu', native_name: 'اردو' },
  { code: 'uz', english_name: 'Uzbek', native_name: "o'zbek" },
  { code: 'vi', english_name: 'Vietnamese', native_name: 'Tiếng Việt' },
  { code: 'zh-Hans', english_name: 'Chinese (Simplified)', native_name: '简体中文' },
  { code: 'zh-CN', english_name: 'Chinese (Mainland China)', native_name: '简体中文 (中国)' },
  { code: 'zh-Hant', english_name: 'Chinese (Traditional)', native_name: '繁體中文' },
  { code: 'zh-TW', english_name: 'Chinese (Taiwan)', native_name: '繁體中文 (台灣)' },
  { code: 'zu', english_name: 'Zulu', native_name: 'isizulu' },
];

export default languages;
